/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M18 0H0v18h18Zm-1 17.05H.95V.95h16.09ZM6.3 15.1v-1H4.48l2.3-2.3-.68-.67-2.25 2.37v-1.84h-1v3.47Zm5.58-8.31 2.31-2.29v1.84h1V2.88h-3.44v1h1.82l-2.3 2.3.68.68Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'SquareWithTwoOppositeDiagonalArrowsIcon';

export default Icon;
